// Каталог разделов — зеркало таблицы pages на сервере (миграция 012).
// Ключи должны совпадать с page_key в БД, иначе право просто не найдётся.
export const PAGE_ROUTES = {
    'dashboard': '/dashboard',
    'general': '/general',
    'production': '/production',
    'work-performance': '/work-performance',
    'shipments': '/shipments',
    'orders': '/orders',

    'inventory-materials': '/inventory-materials',
    'inventory-products': '/inventory-products',
    'inventory-fba': '/inventory-fba',

    'material-order-planning': '/material-order-planning',
    'daily-planning': '/daily-planning',
    'sales-forecast': '/sales-forecast',
    'plan-to-produce': '/plan-to-produce',
    'production-plan': '/production-plan',
    'yoy-forecast': '/yoy-forecast',
    'product-cogs': '/product-cogs',
    'material-orders': '/material-orders',
    'shipments-planning': '/shipments-planning',
    'amazon-deals': '/amazon-deals',

    'goods-ordered-report': '/reports/goods-ordered',
    'seeds-receiving-report': '/reports/seeds-receiving',
    'inventory-consumption-report': '/reports/inventory-consumption',

    'scanners': '/scanners',
    'scanner-inv-seeds': '/scannerinvseeds',
    'scanner-inv-fert': '/scannerinvfert',
    'scanner-seeds-stock-check': '/scannerinvseedsstockcheck',
    'scanner-inv-materials': '/scannerainvmaterials',
    'scanner-not-full-boxes': '/scannernotfullboxes',
    'scanner-sealed-sets': '/scannersealedsets',
    'scanner-unsealed-sets': '/scannerunsealedsets',
    'scanner-shipments': '/scannershipments',
    'scanner-amazon-shipments': '/scanners-amazon-shipments',
    'orders-scan': '/orders-scan',
    'get-labels': '/get-labels',

    'admin-users': '/admin/users',
    'admin-roles': '/admin/roles',
    'admin-audit': '/admin/audit',
    'docs': '/docs',
};

/**
 * Какому разделу принадлежит путь. Сравниваем по сегментам, иначе '/scanners'
 * поймал бы '/scanners-amazon-shipments'. Для вложенных путей вида
 * /material-orders/tab/123 берём самое длинное совпадение.
 */
export function pageKeyForPath(pathname) {
    let best = null;
    for (const [key, route] of Object.entries(PAGE_ROUTES)) {
        if (pathname === route || pathname.startsWith(route + '/')) {
            if (!best || route.length > PAGE_ROUTES[best].length) best = key;
        }
    }
    return best;
}
